<template>
  <div class="wrapper">
    <div class="top-nav">
      <div>
        <nav-common :nav="nav"></nav-common>
      </div>
    </div>
    <div class="list">
      <list-item v-for="item in newList" :key="'new'+item.id" :itemData="item" @toPage="getDetail"></list-item>
    </div>
    <div>
      <model-page :dataObj="ariList" @nextPage="nextPage"></model-page>
    </div>
  </div>
</template>
<style scoped>
.top-nav {
  width: 100%;
  display: flex;
}
.search {
  width: 310px;
  margin-right: 30px;
}
.list {
  width: 100%;
  border-width: 20px 1px 1px 1px;
  border-style: solid;
  border-color: #e6ecf2;
  padding: 40px 30px;
  box-sizing: border-box;
  border-radius: 10px;
}
</style>

<script>
import navCommon from "@/components/views/common/nav.vue";
import listItem from "@/components/views/common/listItem.vue";
import ModelPage from "@/components/views/common/ModelPage";
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      nav: {
        firsttitle: "公告",
        firstrouteName: "announceList",
        secondtitle: "",
        secondrouteName: "",
        thirdtitle: "",
        thirdrouteName: ""
      },
      ariList: [], //分页所需的值
      newList: [],
      page: 1,
      count: 10,
      search_word: ""
    };
  },
  computed: {
    ...mapGetters(["searchVuex"])
  },
  methods: {
    ...mapActions(["setSearch"]),
    getNoticeList() {
      const params = {
        type: this.$route.query.annoceFlag,
        page: this.page,
        count: this.count,
        search_word: this.search_word
      };
      userApi.getNoticeList(params).then(res => {
        this.ariList = res.data;
        this.newList = res.data.list;
        if (this.ariList.total == "1") {
          this.$router.push({
            name: "announceDetail",
            query: {
              annoceFlag: this.$route.query.annoceFlag,
              id: this.newList[0].id
            }
          });
        }
      });
    },
    nextPage(pageNo) {
      this.page = pageNo;
      this.getNoticeList();
    },
    getDetail(id) {
      this.$router.push({
        name: "announceDetail",
        query: {
          annoceFlag: this.$route.query.annoceFlag,
          id: id
        }
      });
    },
    // 初始化路由
    handleRoute() {
      this.count = 10;
      this.page = 1;
      if (!this.$route.query.annoceFlag) {
        this.$router.push({
          name: "announceList",
          query: {
            annoceFlag: "1"
          }
        });
      }
      if (this.$route.query.annoceFlag == "2") {
        this.nav.secondtitle = "重要公告";
      } else {
        this.nav.secondtitle = "重要活动";
      }
    }
  },
  components: {
    navCommon,
    listItem,
    ModelPage
  },
  watch: {
    $route() {
      this.handleRoute();
      this.getNoticeList();
    },
    searchVuex(newArr, oldArr) {
      this.search_word = newArr;
      if (this.search_word == "") {
        this.getNoticeList();
      }
      this.getNoticeList();
    }
  },
  mounted() {
    this.handleRoute();
    this.getNoticeList();
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/Announce/list.vue